import LogoAnimation from './LogoAnimation';

export default class LogoArea {
	constructor(area) {
		this.breakpoint = window.matchMedia('(orientation: portrait)');

		this.players = area.querySelectorAll('[data-anim]');
		this.playerInstances = [...this.players].map((player) => new LogoAnimation(player, this));

		if (this.breakpoint.matches === true) {
			// Portrait
			// setTimeout(() => {
			// 	this.show('a');
			// }, 1000);

			document.addEventListener('preload-anim-done', () => {
				this.show('a');
			});

		}
	}

	show(animation) {
		this.targetAnimation = animation;
		const alreadyRunning = this.playerInstances.filter((x) => x.running).length > 0;

		this.playerInstances.forEach((player) => {
			player.setShouldStop(player.animation != animation);
		});

		if (!alreadyRunning) {
			this.startTargetAnimation();
		}
	}

	finishedPlayer() {
		if (this.breakpoint.matches === true) {
			// Portrait
			if (this.targetAnimation === 'a') {
				this.targetAnimation = 'b';
			} else if (this.targetAnimation === 'b') {
				this.targetAnimation = 'c';
			} else if (this.targetAnimation === 'c') {
				this.targetAnimation = 'd';
			} else if (this.targetAnimation === 'd') {
				this.targetAnimation = 'a';
			}
		}
		this.startTargetAnimation();
	}

	startTargetAnimation() {
		if (this.targetAnimation) {
			this.playerInstances.forEach((player) => {
				player.player.classList.remove('is-playing');
			});
		}

		this.playerInstances
			.filter((x) => x.animation == this.targetAnimation)
			.forEach((player) => {
				player.start();
			});
	}
}